import css from "styled-jsx/css";
import {
  BACKGROUND_GRAY_COLOR_NAME,
  BRAND_AND_WORK_MANAGEMENT_DARK_TINT_01,
  BRAND_WORK_MANAGEMENT_LIGHTER_TINT_01
} from "styles/color-consts";
import Colors from "styles/colors";

export const componentStyles = css.global`
  .structured-header-menu-left-panel {
    width: 400px;
    padding: 24px 24px 24px 0;
    box-shadow: 32px 0 40px -32px rgba(29, 140, 242, 0.16);
    .inner-menu-item {
      display: flex;
      flex-direction: column;
      &.selected {
        .inner-menu-item-title {
          color: ${Colors[BRAND_AND_WORK_MANAGEMENT_DARK_TINT_01]};
          .expand-arrow {
            path {
              fill: ${Colors[BRAND_AND_WORK_MANAGEMENT_DARK_TINT_01]};
            }
          }
        }
        .inner-menu-item-subitems {
          max-height: 160px;
        }
      }
      .inner-menu-item-title {
        font-size: 1rem;
        font-weight: 400;
        cursor: pointer;
        display: flex;
        gap: 8px;
        align-items: center;
        .expand-arrow {
          transform: rotate(-90deg);
          transition: 0.15s transform ease-in-out;
          display: flex;
          height: 8px;
          margin-bottom: 4px;
          &.down-direction {
            transform: rotate(0deg);
          }
        }
      }
      .inner-menu-item-subitems {
        display: flex;
        flex-direction: column;
        border-left: ${`2px solid ${Colors[BACKGROUND_GRAY_COLOR_NAME]}`};
        margin: 16px 0;
        max-height: 0px;
        overflow: hidden;
        transition: 0.15s max-height ease-in-out;
        .inner-menu-item-subitem {
          display: flex;
          justify-content: space-between;
          cursor: pointer;
          font-size: 1rem;
          line-height: 48px;
          padding-left: 40px;
          border-top-right-radius: 8px;
          border-bottom-right-radius: 8px;
          &.selected {
            background-color: ${Colors[BRAND_WORK_MANAGEMENT_LIGHTER_TINT_01]};
          }
          .inner-menu-item-subitem-title-and-icon {
            align-items: center;
            display: flex;
          gap: 16px;
          }
          .inner-menu-item-subitem-title-arrow {
              margin-right: 16px;
            .arrow-icon {
              height: 10px;
            }
          }
        }
      }
    }
  }
`;
